var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-2",attrs:{"align":"start"}},[_c('v-col',{staticClass:"px-0",attrs:{"cols":"12"}},[_vm._t("title"),_vm._t("subTitle")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }